<template>
  <div class="comp">
    <div class="compContent">
      <div class="title">
        <div class="titleL">药房</div>
        <div class="titleR"></div>
      </div>
      <div class="content">
        <div class="con">
          <div class="tabLine">
            <div class="tabLineL">
              <!-- <div class="tabItem" :class="[yaofangParams.tabIndex===0?'active':'']" @click="changeTabIndex(0)">病例</div> -->
              <div
                class="tabItem"
                :class="[yaofangParams.tabIndex === 1 ? 'active' : '']"
                @click="changeTabIndex(1)"
              >
                疫苗驱虫
              </div>
              <div
                class="tabItem"
                :class="[yaofangParams.tabIndex === 2 ? 'active' : '']"
                @click="changeTabIndex(2)"
              >
                医疗服务
              </div>
            </div>
            <div class="tabLineR"></div>
          </div>
          <!-- <div v-if="yaofangParams.tabIndex === 0" class="elTable">
            <list0 ref="list0"></list0>
          </div> -->
          <div v-if="yaofangParams.tabIndex === 1" class="elTable">
            <list1 ref="list1"></list1>
          </div>
          <div v-if="yaofangParams.tabIndex === 2" class="elTable">
            <list2 ref="list2"></list2>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import list0 from "./pharmacy_list0.vue";
import list1 from "./pharmacy_list1.vue";
import list2 from "./pharmacy_list2.vue";
export default {
  components: { list1, list2 },
  data() {
    return {};
  },
  computed: {
    yaofangParams() {
      return this.$store.state.yiliaoxin.yaofangParams;
    },
  },
  // beforeRouteEnter(to,from,next){
  // 	if(from.path==='/yiliao/inputBarCode'){
  // 		next(vm=>{
  // 			vm.$refs['list'+vm.curTab].getTableData();
  // 		})
  // 	}else{
  // 		next()
  // 	}
  // },
  created() {},
  mounted() {},
  methods: {
    changeTabIndex(index) {
      this.yaofangParams.tabIndex = index;
      this.$store.commit("yiliaoxin/set_yaofangParams", this.yaofangParams);
    },
  },
};
</script>
<style scoped lang="scss">
.comp {
  position: relative;
  height: 100%;
  box-sizing: border-box;
  .compContent {
    height: 100%;
    background-color: #fff;
    border-radius: 12px;
    overflow: auto;
    .title {
      display: flex;
      height: 47px;
      line-height: 27px;
      border-bottom: 1px solid #f2f2f2;
      padding: 10px 18px;
      box-sizing: border-box;
      .titleL {
        width: 50%;
        font-size: 14px;
        font-weight: bold;
      }
      .titleR {
        width: 50%;
        text-align: right;
        .titleRText {
          display: inline-block;
          font-size: 14px;
          color: $mainColor;
          margin-left: 40px;
          cursor: pointer;
        }
      }
    }
    .content {
      position: relative;
      width: 100%;
      height: calc(100% - 47px);
      box-sizing: border-box;
      .con {
        width: 100%;
        height: 100%;
        .tabLine {
          height: 60px;
          padding: 16px 20px 12px;
          box-sizing: border-box;
          display: flex;
          justify-content: space-between;
          .tabLineL {
            display: flex;
            .tabItem {
              width: 90px;
              text-align: center;
              line-height: 32px;
              border-radius: 19px;
              background-color: #f7f7f7;
              color: #73737b;
              font-size: 14px;
              margin-right: 20px;
              border: 1px solid transparent;
              cursor: pointer;
              font-weight: bold;
              &.active {
                color: $mainColor;
                background-color: #fff9f3;
                border-color: $mainColor;
              }
            }
          }
          .tabLineR {
          }
        }
        .searchLine {
          padding: 8px 20px 20px;
          box-sizing: border-box;
          display: flex;
          .searchLineL {
            display: flex;
            .searchLabel {
              font-size: 12px;
              color: $fontColor;
              line-height: 32px;
              margin-left: 10px;
            }
          }
          .searchLineR {
          }
        }
        .elTable {
          height: calc(100% - 60px);
        }
      }
      .pageBox {
        position: absolute;
        bottom: 0;
        width: 100%;
      }
    }
  }
}
</style>
